export const ROLE_PERMISSION_KEY = {
  DASHBOARD: {
    DASHBOARD_MANAGEMENT: 'dashboard_management',
    DASHBOARD: 'dashboard',
    DASHBOARD_MONITORING: 'dashboard_monitoring',
    DASHBOARD_MONITORING_ALERT_VIEW: 'dashboard_monitoring_alert_view',
    DASHBOARD_MONITORING_ALERT_VIEW_CLEAR: 'dashboard_monitoring_alert_view_clear',
    DASHBOARD_GROUP: 'dashboard_group',
    DASHBOARD_GROUP_EDIT: 'dashboard_group_edit', // add, edit, delete 2024.05.30 통합
    DASHBOARD_LIST: 'dashboard_list',
    DASHBOARD_LIST_EDIT: 'dashboard_list_edit', // add, edit, delete 2024.05.30 통합
    DASHBOARD_LIST_MOVE: 'dashboard_list_move',
    DASHBOARD_LIST_EXPORT: 'dashboard_list_export',
    DASHBOARD_LIST_SHARE: 'dashboard_list_share',
    DASHBOARD_LIST_SET_REPORT: 'dashboard_list_set_report',
    DASHBOARD_LIST_SETUP_DASHBOARD_BY_MENU: 'dashboard_list_setup_dashboard_by_menu',
    DASHBOARD_LIST_SETUP_ANALYSIS_BOARD_BY_MENU: 'dashboard_list_setup_analysis_board_by_menu',
    DASHBOARD_LIST_IMPORT: 'dashboard_list_import',
    DASHBOARD_LIST_IMPORT_VIEWPACK: 'dashboard_list_import_viewpack',
    DASHBOARD_FEATURED_DASHBOARD: 'dashboard_featured_dashboard',
    DASHBOARD_FEATURED_DASHBOARD_SET_AS_START_SCREEN:
      'dashboard_featured_dashboard_set_as_start_screen',
    DASHBOARD_FEATURED_DASHBOARD_SETUP_DASHBOARD_BY_MENU:
      'dashboard_featured_dashboard_setup_dashboard_by_menu',
    DASHBOARD_FEATURED_ANALYSIS_BOARD_SETUP_DASHBOARD_BY_MENU:
      'dashboard_featured_analysis_board_setup_dashboard_by_menu',
    DASHBOARD_FEATURED_DASHBOARD_EXPORT: 'dashboard_featured_dashboard_export',
    DASHBOARD_FEATURED_REPORT: 'dashboard_featured_report',
    DASHBOARD_FEATURED_REPORT_SET_AS_START_SCREEN: 'dashboard_featured_report_set_as_start_screen',
    DASHBOARD_FEATURED_REPORT_SETUP_DASHBOARD_BY_MENU:
      'dashboard_featured_report_setup_dashboard_by_menu',
    DASHBOARD_FEATURED_REPORT_SETUP_ANALYSIS_BOARD_BY_MENU:
      'dashboard_featured_report_setup_analysis_board_by_menu',
    DASHBOARD_FEATURED_REPORT_EXPORT: 'dashboard_featured_report_export',
    DASHBOARD_EDIT_VIEWPACK: 'dashboard_edit_viewpack', // add, edit, delete 2024.05.30 통합
    DASHBOARD_EDIT_VIEWPACK_EDIT: 'dashboard_edit_viewpack_edit',
    DASHBOARD_EDIT_VIEWPACK_EXPORT: 'dashboard_edit_viewpack_export',
  },
  MONITORING: {
    MONITORING_MANAGEMENT: 'monitoring_management',
    MONITORING_INFRASTRUCTURE: 'monitoring_infrastructure',
    MONITORING_INFRASTRUCTURE_DASHBOARD: 'monitoring_infrastructure_dashboard',
    MONITORING_INFRASTRUCTURE_HOST: 'monitoring_infrastructure_host',
    MONITORING_INFRASTRUCTURE_CONTAINER: 'monitoring_infrastructure_container',
    MONITORING_INFRASTRUCTURE_NETWORK_DEVICE: 'monitoring_infrastructure_network_device',
    MONITORING_INFRASTRUCTURE_NETWORK_PERFORMANCE_MONITORING:
      'monitoring_infrastructure_network_performance_monitoring',
    // GPU 는 인프라 하위가 아니라 GNB 최상위 도메인(BASE_MENU_VALUE.GPU)이므로 권한도 같은 계층으로 둔다.
    // 키는 화면 이름을 그대로 따른다 — 그룹='GPU 모니터링', 하위 3번째 화면='GPU'.
    // (부모/자식 접두사 규칙보다 키↔표기 일치를 우선한 선택)
    MONITORING_GPU_MONITORING: 'monitoring_gpu_monitoring',
    MONITORING_GPU_RESOURCE: 'monitoring_gpu_resource',
    MONITORING_GPU_WORKLOAD: 'monitoring_gpu_workload',
    MONITORING_GPU: 'monitoring_gpu',
    MONITORING_MESSAGEQUEUE: 'monitoring_messageQueue',
    MONITORING_MESSAGEQUEUE_DASHBOARD: 'monitoring_messageQueue_dashboard',
    MONITORING_MESSAGEQUEUE_KAFKA: 'monitoring_messageQueue_kafka',
    MONITORING_KUBERNETES: 'monitoring_kubernetes',
    MONITORING_KUBERNETES_INFRASTRUCTURE: 'monitoring_kubernetes_infrastructure',
    MONITORING_KUBERNETES_SCALING: 'monitoring_kubernetes_scaling',
    MONITORING_KUBERNETES_STORAGE: 'monitoring_kubernetes_storage',
    MONITORING_KUBERNETES_CONFIGURATION: 'monitoring_kubernetes_configuration',
    MONITORING_KUBERNETES_INVENTORY: 'monitoring_kubernetes_inventory',
    MONITORING_KUBERNETES_DASHBOARD: 'monitoring_kubernetes_dashboard',
    MONITORING_KUBERNETES_POD_KILL: 'monitoring_kubernetes_pod_kill',
    MONITORING_KUBERNETES_POD_SHELL: 'monitoring_kubernetes_pod_shell',
    MONITORING_KUBERNETES_WORKLOAD: 'monitoring_kubernetes_workload',
    MONITORING_KUBERNETES_NETWORK: 'monitoring_kubernetes_network',
    MONITORING_KUBERNETES_ACCESS_CONTROL: 'monitoring_kubernetes_access_control',
    MONITORING_KUBERNETES_ANALYSIS: 'monitoring_analysis_kubernetes',
    MONITORING_CLOUD: 'monitoring_cloud',
    MONITORING_CLOUD_DASHBOARD: 'monitoring_cloud_dashboard',
    MONITORING_CLOUD_COMPUTING: 'monitoring_cloud_computing',
    MONITORING_CLOUD_STORAGE: 'monitoring_cloud_storage',
    MONITORING_CLOUD_DATABASE: 'monitoring_cloud_database',
    MONITORING_CLOUD_AWS: 'monitoring_cloud_aws',
    MONITORING_CLOUD_AWS_EC2: 'monitoring_cloud_aws_ec2',
    MONITORING_CLOUD_AWS_LAMBDA: 'monitoring_cloud_aws_lambda',
    MONITORING_CLOUD_AWS_S3: 'monitoring_cloud_aws_s3',
    MONITORING_CLOUD_AWS_DOCUMENT_DB: 'monitoring_cloud_aws_document_db',
    MONITORING_CLOUD_AWS_DYNAMO_DB: 'monitoring_cloud_aws_dynamo_db',
    MONITORING_CLOUD_AWS_ELASTI_CACHE: 'monitoring_cloud_aws_elasti_cache',
    MONITORING_CLOUD_AWS_RDS: 'monitoring_cloud_aws_rds',
    MONITORING_CLOUD_AWS_REDSHIFT: 'monitoring_cloud_aws_red_shift',
    MONITORING_CLOUD_AWS_DATABASE_MIGRATION: 'monitoring_cloud_aws_database_migration',
    MONITORING_CLOUD_AWS_COST_EXPLORER: 'monitoring_cloud_aws_explorer_cost',
    MONITORING_APPLICATION: 'monitoring_application',
    MONITORING_APPLICATION_DASHBOARD: 'monitoring_application_dashboard',
    MONITORING_APPLICATION_WAS: 'monitoring_application_was',
    MONITORING_APPLICATION_WAS_OVERVIEW: 'monitoring_application_was_overview',
    MONITORING_APPLICATION_WAS_HEAP_DUMP: 'monitoring_application_was_heap_dump',
    MONITORING_APPLICATION_WAS_BIND_VARIABLE: 'monitoring_application_was_view_bind_variables',
    MONITORING_APPLICATION_WAS_CLASS_PROFILING: 'monitoring_application_was_class_profiling',
    MONITORING_APPLICATION_TRANSACTION: 'monitoring_application_transaction',
    MONITORING_APPLICATION_WEB_SERVER: 'monitoring_application_web_server',
    MONITORING_APPLICATION_URL_MONITORING: 'monitoring_application_url_monitoring',
    MONITORING_APPLICATION_REAL_USER_MONITORING: 'monitoring_application_real_user_monitoring',
    MONITORING_APPLICATION_WEB_APPLICATION: 'monitoring_application_web_application',
    MONITORING_APPLICATION_PAGE_PERFORMANCE_MONITORING:
      'monitoring_application_page_performance_monitoring',
    MONITORING_APPLICATION_BROWSER_ERROR_TRACKING: 'monitoring_application_browser_error_tracking',
    MONITORING_APPLICATION_USER_MONITORING: 'monitoring_application_user_monitoring',
    MONITORING_APPLICATION_ANALYSIS: 'monitoring_analysis_application',
    MONITORING_DATABASE: 'monitoring_database',
    MONITORING_DATABASE_DASHBOARD: 'monitoring_database_dashboard',
    MONITORING_DATABASE_INSTANCE: 'monitoring_database_instance',
    MONITORING_DATABASE_INSTANCE_SESSION_KILL: 'monitoring_database_instance_session_kill',
    MONITORING_DATABASE_INSTANCE_BIND_VARIABLE: 'monitoring_database_instance_bind_variable',
    MONITORING_DATABASE_INSTANCE_SESSION_MANAGER: 'monitoring_database_instance_session_manager',
    MONITORING_DATABASE_ALTIBASE: 'monitoring_database_altibase',
    MONITORING_DATABASE_CLICKHOUSE: 'monitoring_database_clickhouse',
    MONITORING_DATABASE_MYSQL: 'monitoring_database_mysql',
    MONITORING_DATABASE_ORACLE: 'monitoring_database_oracle',
    MONITORING_DATABASE_POSTGRESQL: 'monitoring_database_postgresql',
    MONITORING_DATABASE_REDSHIFT: 'monitoring_database_redshift',
    MONITORING_DATABASE_SQLSERVER: 'monitoring_database_sqlserver',
    MONITORING_DATABASE_SINGLESTORE: 'monitoring_database_singlestore',
    MONITORING_DATABASE_TIBERO: 'monitoring_database_tibero',
    MONITORING_DATABASE_ALTIBASE_DASHBOARD: 'monitoring_database_altibase_dashboard',
    MONITORING_DATABASE_POSTGRESQL_DASHBOARD: 'monitoring_database_postgresql_dashboard',
    MONITORING_DATABASE_MYSQL_DASHBOARD: 'monitoring_database_mysql_dashboard',
    MONITORING_DATABASE_SQLSERVER_DASHBOARD: 'monitoring_database_sqlserver_dashboard',
    MONITORING_DATABASE_TIBERO_DASHBOARD: 'monitoring_database_tibero_dashboard',
    MONITORING_DATABASE_SINGLESTORE_DASHBOARD: 'monitoring_database_singlestore_dashboard',
    MONITORING_DATABASE_ORACLE_DASHBOARD: 'monitoring_database_oracle_dashboard',
    MONITORING_DATABASE_ALTIBASE_PA: 'monitoring_database_altibase_pa',
    MONITORING_DATABASE_CLICKHOUSE_PA: 'monitoring_database_clickhouse_pa',
    MONITORING_DATABASE_MYSQL_PA: 'monitoring_database_mysql_pa',
    MONITORING_DATABASE_ORACLE_PA: 'monitoring_database_oracle_pa',
    MONITORING_DATABASE_POSTGRESQL_PA: 'monitoring_database_postgresql_pa',
    MONITORING_DATABASE_REDSHIFT_PA: 'monitoring_database_redshift_pa',
    MONITORING_DATABASE_SQLSERVER_PA: 'monitoring_database_sqlserver_pa',
    MONITORING_DATABASE_SINGLESTORE_PA: 'monitoring_database_singlestore_pa',
    MONITORING_DATABASE_TIBERO_PA: 'monitoring_database_tibero_pa',
    MONITORING_DATABASE_ANALYSIS: 'monitoring_analysis_database',
    // <-- Maxgauge Mode
    MONITORING_ORACLE: 'monitoring_oracle',
    MONITORING_ORACLE_DASHBOARD: 'monitoring_oracle_dashboard',
    MONITORING_ORACLE_PERFORMANCE_ANALYSIS: 'monitoring_oracle_maxgauge_pa',
    MONITORING_POSTGRESQL: 'monitoring_postgresql',
    MONITORING_POSTGRESQL_DASHBOARD: 'monitoring_postgresql_dashboard',
    MONITORING_POSTGRESQL_PERFORMANCE_ANALYSIS: 'monitoring_postgresql_maxgauge_pa',

    MONITORING_MYSQL: 'monitoring_mysql',
    MONITORING_MYSQL_DASHBOARD: 'monitoring_mysql_dashboard',
    MONITORING_MYSQL_PERFORMANCE_ANALYSIS: 'monitoring_mysql_maxgauge_pa',
    MONITORING_SQLSERVER: 'monitoring_sqlserver',
    MONITORING_SQLSERVER_DASHBOARD: 'monitoring_sqlserver_dashboard',
    MONITORING_SQLSERVER_PERFORMANCE_ANALYSIS: 'monitoring_sqlserver_maxgauge_pa',
    MONITORING_REDIS: 'monitoring_redis',
    MONITORING_REDIS_DASHBOARD: 'monitoring_redis_dashboard',
    MONITORING_CUBRID: 'monitoring_cubrid',
    MONITORING_CUBRID_DASHBOARD: 'monitoring_cubrid_dashboard',
    MONITORING_MONGO: 'monitoring_mongo',
    MONITORING_MONGO_DASHBOARD: 'monitoring_mongo_dashboard',
    MONITORING_TIBERO: 'monitoring_tibero',
    MONITORING_TIBERO_DASHBOARD: 'monitoring_tibero_dashboard',
    MONITORING_TIBERO_PERFORMANCE_ANALYSIS: 'monitoring_tibero_maxgauge_pa',
    MONITORING_ALTIBASE: 'monitoring_altibase',
    MONITORING_ALTIBASE_DASHBOARD: 'monitoring_altibase_dashboard',
    MONITORING_ALTIBASE_PERFORMANCE_ANALYSIS: 'monitoring_altibase_maxgauge_pa',
    MONITORING_CLICKHOUSE: 'monitoring_clickhouse',
    MONITORING_CLICKHOUSE_DASHBOARD: 'monitoring_clickhouse_dashboard',
    MONITORING_CLICKHOUSE_PERFORMANCE_ANALYSIS: 'monitoring_clickhouse_maxgauge_pa',
    MONITORING_REDSHIFT: 'monitoring_redshift',
    MONITORING_REDSHIFT_DASHBOARD: 'monitoring_redshift_dashboard',
    MONITORING_REDSHIFT_PERFORMANCE_ANALYSIS: 'monitoring_redshift_maxgauge_pa',
    MONITORING_SINGLESTORE: 'monitoring_singlestore',
    MONITORING_SINGLESTORE_DASHBOARD: 'monitoring_singlestore_dashboard',
    MONITORING_SINGLESTORE_PERFORMANCE_ANALYSIS: 'monitoring_singlestore_maxgauge_pa',
    // Maxgauge Mode -->
    MONITORING_BUSINESS: 'monitoring_business',
    MONITORING_BUSINESS_DASHBOARD: 'monitoring_business_dashboard',
    MONITORING_BUSINESS_LIST: 'monitoring_business_list',
    MONITORING_BUSINESS_MAP: 'monitoring_business_map',
    MONITORING_BUSINESS_MAP_FAULT_CONTROL: 'monitoring_business_map_fault_control',
    MONITORING_LOGS: 'monitoring_logs',
    MONITORING_LOGS_DASHBOARD: 'monitoring_logs_dashboard',
    MONITORING_LOGS_LOGGING: 'monitoring_logs_logging',
    MONITORING_LOGS_LIVE_TAIL: 'monitoring_logs_live_tail',
    MONITORING_LOGS_LOGGING_TREND: 'monitoring_logs_logging_trend',
    MONITORING_ALERT: 'monitoring_alert',
    MONITORING_ALERT_DASHBOARD: 'monitoring_alert_dashboard',
    MONITORING_ALERT_LIST: 'monitoring_alert_list',
    MONITORING_ALERT_LIST_CLEAR: 'monitoring_alert_list_clear',
    MONITORING_ALERT_EVENT_ALERT_LIST: 'monitoring_alert_event_alert_list',
    MONITORING_ALERT_NOTIFICATION_HISTORY: 'monitoring_alert_notification_history',
    MONITORING_ANALYSIS: 'monitoring_analysis',
    MONITORING_REPORT: 'monitoring_report',
    MONITORING_REPORT_ALERT_HISTORY: 'monitoring_report_alert_history',
    MONITORING_DASHBOARD_REPORT_EXPORT: 'monitoring_report_export',
    MONITORING_BUSINESS_REPORT_EXPORT: 'monitoring_business_report',
    MONITORING_TEMPLATE_REPORT_EXPORT: 'monitoring_template_report_export',
    MONITORING_PREDEFINED_REPORT: 'monitoring_predefined_report',
    MONITORING_PREDEFINED_REPORT_HISTORY: 'monitoring_predefined_report_history',
    MONITORING_PREDEFINED_REPORT_EXPORT: 'monitoring_predefined_report_export',
    MONITORING_AIOPS: 'monitoring_aiOps',
    MONITORING_AI_ASSISTANT: 'monitoring_ai_assistant',
    MONITORING_USER_MANUAL: 'monitoring_user_guide',
    MONITORING_TOOL: 'monitoring_infrastructure_tool',
    MONITORING_TOOL_SCRIPT_MANAGER: 'monitoring_infrastructure_tool_script_manager',
    MONITORING_TOOL_SCRIPT_MANAGER_HISTORY: 'monitoring_infrastructure_tool_script_manager_history',
    MONITORING_TOOL_QUERY_MANAGER: 'tool_query_manager',
    MONITORING_TOOL_QUERY_MANAGER_HISTORY: 'tool_query_manager_history',
  },
  SETTING: {
    SETTING_MANAGEMENT: 'setting_management',
    SETTING_ACCOUNT: 'setting_account',
    SETTING_ACCOUNT_USER_USER_GROUP: 'setting_account_user_user_group',
    SETTING_ACCOUNT_USER_MANAGEMENT: 'setting_account_user_management',
    SETTING_ACCOUNT_USER_MANAGEMENT_GOOGLE_OTP: 'setting_account_user_management_google_otp',
    SETTING_PLATFORM: 'setting_platform',
    SETTING_PLATFORM_INFRASTRUCTURE: 'setting_platform_infrastructure',
    SETTING_PLATFORM_INFRASTRUCTURE_HOST: 'setting_platform_infrastructure_host',
    SETTING_PLATFORM_INFRASTRUCTURE_NETWORK_PERFORMANCE_MONITORING:
      'setting_platform_infrastructure_network_performance_monitoring',
    SETTING_PLATFORM_INFRASTRUCTURE_NETWORK_DEVICE:
      'setting_platform_infrastructure_network_device',
    SETTING_PLATFORM_INFRASTRUCTURE_OID_PACK_MANAGER:
      'setting_platform_infrastructure_oid_pack_manager',
    SETTING_PLATFORM_INFRASTRUCTURE_MESSAGE_QUEUE: 'setting_platform_infrastructure_message_queue',
    SETTING_PLATFORM_CLOUD: 'setting_platform_cloud',
    SETTING_PLATFORM_CLOUD_RESOURCE: 'setting_platform_cloud_resource',
    SETTING_PLATFORM_CLOUD_ACCOUNT: 'setting_platform_cloud_account',
    SETTING_PLATFORM_CLOUD_COLLECTOR: 'setting_platform_cloud_collector',

    SETTING_PLATFORM_KUBERNETES: 'setting_platform_kubernetes',
    SETTING_PLATFORM_KUBERNETES_CLUSTER: 'setting_platform_kubernetes_cluster',
    SETTING_PLATFORM_APPLICATION: 'setting_platform_application',
    SETTING_PLATFORM_APPLICATION_WAS: 'setting_platform_application_was',
    SETTING_PLATFORM_APPLICATION_WEB_SERVER: 'setting_platform_application_web_server',
    SETTING_PLATFORM_APPLICATION_URL_MONITORING: 'setting_platform_application_url_monitoring',
    SETTING_PLATFORM_APPLICATION_REAL_USER_MONITORING:
      'setting_platform_application_real_user_monitoring',
    SETTING_PLATFORM_DATABASE: 'setting_platform_database',
    SETTING_PLATFORM_USER_INTEGRATION: 'setting_platform_user_integration',
    SETTING_PLATFORM_DATABASE_INSTANCE: 'setting_platform_database_instance',
    SETTING_MONITORING: 'setting_monitoring',
    SETTING_MONITORING_BUSINESS: 'setting_monitoring_business',
    SETTING_MONITORING_LOG: 'setting_monitoring_log',
    SETTING_MONITORING_LOG_LOGGING: 'setting_monitoring_log_logging',
    SETTING_MONITORING_LOG_LOGGING_TREND: 'setting_monitoring_log_logging_trend',
    SETTING_MONITORING_LOG_PATH: 'setting_monitoring_log_path',
    SETTING_MONITORING_REPORT: 'setting_monitoring_report',
    SETTING_MONITORING_REPORT_DASHBOARD_EXPORT: 'setting_monitoring_report_dashboard_export',
    SETTING_MONITORING_REPORT_TEMPLATE_REPORT: 'setting_monitoring_report_template_report_export',
    SETTING_MONITORING_REPORT_BUSINESS_EXPORT: 'setting_business_report_dashboard_export',
    SETTING_MONITORING_REPORT_SCHEDULE: 'setting_monitoring_report_schedule',
    SETTING_MONITORING_PREDEFINED_REPORT: 'setting_monitoring_predefined_report',
    SETTING_MONITORING_PREDEFINED_REPORT_REPORT: 'setting_monitoring_predefined_report_report',
    SETTING_MONITORING_PREDEFINED_REPORT_SCHEDULE: 'setting_monitoring_predefined_report_schedule',
    SETTING_MONITORING_PREDEFINED_REPORT_DATA_BLOCK:
      'setting_monitoring_predefined_report_data_block',
    SETTING_MONITORING_EXTERNAL_RESOURCE: 'setting_monitoring_external_resource',
    SETTING_MONITORING_EXTERNAL_INTEGRATION: 'setting_monitoring_external_integration',
    SETTING_MONITORING_EXTERNAL_INTEGRATION_PRODUCT:
      'setting_monitoring_external_integration_product',

    SETTING_ASSET: 'setting_asset',
    SETTING_ASSET_EOL_EOS: 'setting_asset_eol_eos',
    SETTING_ASSET_EOL_EOS_TARGET: 'setting_asset_eol_eos_target',
    SETTING_ASSET_EOL_EOS_POLICY: 'setting_asset_eol_eos_policy',

    SETTING_ALERT: 'setting_alert',
    SETTING_ALERT_USER_ALERT: 'setting_alert_user_alert',
    SETTING_ALERT_SYSTEM_ALERT: 'setting_alert_system_alert',
    SETTING_ALERT_EXTERNAL_ALERT: 'setting_alert_external_alert',
    SETTING_ALERT_NOTIFICATION: 'setting_alert_notification',
    SETTING_ALERT_PRESET: 'setting_alert_preset',
    SETTING_MANAGEMENT_MANAGEMENT: 'setting_management_management',
    SETTING_MANAGEMENT_AGENT: 'setting_management_agent',
    SETTING_MANAGEMENT_AGENT_EXECUTION: 'setting_management_execution',
    SETTING_MANAGEMENT_AGENT_LIST: 'setting_management_agent_list',
    SETTING_MANAGEMENT_AGENT_PATCH: 'setting_management_agent_patch',
    SETTING_MANAGEMENT_AGENT_PATCH_HISTORY: 'setting_management_agent_patch_history',
    SETTING_MANAGEMENT_DATA: 'setting_management_data',
    SETTING_MANAGEMENT_DATA_RETENTION: 'setting_management_data_retention',
    SETTING_MANAGEMENT_DATA_METRIC_COLLECTION_CYCLE_MANAGEMENT:
      'setting_management_data_metric_collection_cycle_management',
    SETTING_MANAGEMENT_DATA_STAT: 'setting_management_data_stat',
    SETTING_MANAGEMENT_TAG: 'setting_management_tag',
    SETTING_MANAGEMENT_CUSTOM_STAT: 'setting_management_custom_stat',
    SETTING_MANAGEMENT_LICENSE: 'setting_management_license',
    SETTING_MANAGEMENT_NOTICE: 'setting_management_notice',
    SETTING_MANAGEMENT_SECURITY: 'setting_management_security',
    SETTING_MANAGEMENT_LICENSE_OVERVIEW: 'setting_management_license_overview',
    SETTING_MANAGEMENT_TARGET_ICON: 'setting_management_target_icon',
    SETTING_MANAGEMENT_CUSTOM_TARGET_LINK: 'setting_management_custom_target_link',
    SETTING_MANAGEMENT_AI: 'setting_management_ai',
    SETTING_MANAGEMENT_AI_ANOMALY_DETECTION: 'setting_management_ai_anomaly_detection',
    SETTING_MANAGEMENT_AI_ASSISTANT: 'setting_management_ai_assistant',
  },
};

export const PERMISSION_LIST = {
  DASHBOARD: 'dashboard',
  MONITORING: 'monitoring',
  SETTING: 'setting',
} as const;
